import { Grid, Typography } from '@material-ui/core';
import random from 'lodash/random';
import { useState } from 'react';
import './LoadingScreen.css';

import loadingLegends from './loadingLegends';
import LoadingProgress from './LoadingProgress';

const LoadingScreen = () => {
  const legendIndex = random(0, loadingLegends.length - 1);
  const [legend] = useState(loadingLegends[legendIndex]);
  return (
    <Grid
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        minHeight: '100vh',
      }}
    >
      <LoadingProgress loading={true} width={216} height={216} />
      <Typography variant="h4" className="pulsating">
        {legend}
      </Typography>
    </Grid>
  );
};

export default LoadingScreen;
